module.exports = __webpack_public_path__ + "static/banner-mobile-78be4e0ea005c5e6954d72e178ca5429.jpg";